import { useState } from "react"
import DynamicSquaredFilterBar from "../../../common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import PaymentGateways from "./PaymentGateways/PaymentGateways"
import SavedPaymentMethods from "./SavedPaymentMethods/SavedPaymentMethods"

const PaymentMethods = () => {
  
  const tabs = [
    { key: "paymentGateways", label: "Payment Gateways" },
    { key: "savedPaymentMethods", label: "Saved Payment Methods" },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <LightGrayBgWrapper>
      <div className="shadow">
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="white" />
      </div>

      {activeTab === "paymentGateways" && <PaymentGateways />}
      {activeTab === "savedPaymentMethods" && <SavedPaymentMethods />}
    </LightGrayBgWrapper>
  )
}

export default PaymentMethods
